"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBarGroup = _styledComponents.default.div.withConfig({
  displayName: "ActionBarGroup",
  componentId: "kxkfyk-0"
})(["position:relative;display:flex;&&{margin:-8px 16px -8px 0;}@media ", "{width:100%;&&{margin:0;}&&:not(:last-child){margin:-8px 16px 8px 0;}}"], (0, _helpers.breakpoint)('maxMobile'));

var _default = ActionBarGroup;
exports.default = _default;